import { WorkspaceT } from '@/pages/workgroup/type';
import { compare } from 'compare-versions';

export const supportQueryProfile = (wp: WorkspaceT | undefined) => {
  return !!wp?.tg_version && compare(wp?.tg_version, '4.1.x', '>');
};

/**
 * GLE-13199 `created_at` on secrets:
 * - Primary: 4.4.0+ (test image e.g. `4.4.0-07231942`)
 * - Port To: 4.3.0+, 4.2.5+, 4.1.5+
 * Cloud versions may include a build suffix; compare the release part only.
 */
export function supportSecretCreatedAt(workspace: WorkspaceT | undefined): boolean {
  if (!workspace?.tg_version) {
    return false;
  }

  const cleanVersion = workspace.tg_version.split('-')[0];

  // 4.3.0+ covers 4.3.x and all later lines (including 4.4.0+).
  if (compare(cleanVersion, '4.3.0', '>=')) {
    return true;
  }

  // 4.2.5 through 4.2.x
  if (compare(cleanVersion, '4.2.5', '>=') && compare(cleanVersion, '4.3.0', '<')) {
    return true;
  }

  // 4.1.5 through 4.1.x
  if (compare(cleanVersion, '4.1.5', '>=') && compare(cleanVersion, '4.2.0', '<')) {
    return true;
  }

  return false;
}
